var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jwtDecode } from "jwt-decode";
import { createContext, useCallback, useContext, useEffect, useState, } from "react";
import { useLocation } from "react-router-dom";
import { LocalStorage } from "utility";
import { BuildInfo } from "utility/buildinfo";
import { StorageKey } from "utility/session-storage/constants";
var DEV_BYPASS_USER_ID = "dev-local-user";
var DEV_BYPASS_QUERY_PARAM = "auth-bypass";
var DEV_BYPASS_SESSION_KEY = "piabAuthBypass";
var defaultAuthContext = {
    isAuthenticated: false,
    decodeToken: function () {
        //
    },
};
var AuthContext = createContext(defaultAuthContext);
var devBypassEnabled = function () {
    if (!BuildInfo.isDevEnvironment()) {
        return false;
    }
    var params = new URLSearchParams(window.location.search);
    if (params.get(DEV_BYPASS_QUERY_PARAM) === "1") {
        window.sessionStorage.setItem(DEV_BYPASS_SESSION_KEY, "1");
        return true;
    }
    return window.sessionStorage.getItem(DEV_BYPASS_SESSION_KEY) === "1";
};
export var AuthProvider = function (_a) {
    var children = _a.children;
    var _b = __read(useState(function () {
        return devBypassEnabled() ? DEV_BYPASS_USER_ID : undefined;
    }), 2), userId = _b[0], setUserId = _b[1];
    var _c = __read(useState(function () {
        return devBypassEnabled();
    }), 2), isAuthenticated = _c[0], setIsAuthenticated = _c[1];
    var location = useLocation();
    var isTokenValid = function (expireTime) {
        if (!expireTime) {
            return;
        }
        var currentTime = Math.floor(Date.now() / 1000);
        return currentTime < expireTime;
    };
    var decodeToken = useCallback(function (token) {
        try {
            var decoded = jwtDecode(token);
            var exp = decoded.exp;
            if (isTokenValid(exp)) {
                setUserId(decoded.CrmId);
                setIsAuthenticated(true);
                LocalStorage.setItem(StorageKey.AUTH_TOKEN, token);
            }
        }
        catch (error) {
            console.error("Invalid token:", error);
        }
    }, []);
    useEffect(function () {
        if (isAuthenticated) {
            return;
        }
        var storedToken = LocalStorage.getItem(StorageKey.AUTH_TOKEN);
        if (!storedToken) {
            return;
        }
        decodeToken(storedToken);
    }, [location.search, isAuthenticated, location, decodeToken]);
    return (_jsx(AuthContext.Provider, { value: {
            userId: userId,
            isAuthenticated: isAuthenticated,
            decodeToken: decodeToken,
        }, children: children }));
};
export var useAuthContext = function () { return useContext(AuthContext); };
